import CapaAvatar from './Avatar';
export default CapaAvatar;
